import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import {
  getCreateCourseDefaultFormData,
  getCreateCourseInitailStateForErrors,
  checkMinLength,
  isContainSpecialCharacters,
  isNumericInput,
  checkStartAndEndDate,
  buildSKUString,
} from '../helpers/helpers';

import { CourseBasicDetails, CourseBasicDetailsErrors } from '../types/interfaces/CourseBasicDetails';
import { Goal } from '../types/interfaces/Goal';
import { User } from '../types/interfaces/User';
import DialogHeader from '../../userManagement/common/DialogHeader';
import DialogFooter from '../../userManagement/common/DialogFooter';

import {
  withStyles,
  WithStyles,
  Card,
  CardContent,
  CardActions,
  Checkbox,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  Icon,
  Switch,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { MyPATTextField, MyPATDialog, MyPATSelect, dateService } from '../../common';
import CloseIcon from '@material-ui/icons/Close';
import { courseStyles } from '../styles';
import MyPATCalendar from '../../common/MyPATCalendar';
import Autocomplete from '../../common/Autocomplete';
import {
  getActiveGoals,
  getUserSuggestions,
  addCourseBasicDetails,
  addCourseTestSeries,
} from '../actions/courseManagementActions';
import _ from 'lodash';
import { DateCheck } from '../types/enums/DateCheckResults';
import SearchBarWithChips from '../common/SearchBarWithChipsGoal';
import ACLService from '../../acl/services/aclService';
import { onlyAllowNumbers } from '../../../utils';
import CreateCoursePopup from './CreateCoursePopup/CreateCoursePopup';
import { CourseTypes } from '../types/enums/CourseTypes';
import courseManagementServices from '../service/courseManagementServices';
import { TestSeriesCoursePlan } from '../types/interfaces/CourseBasicDetails';
import { prepareGoalsForSuggestion } from './helper';
import { contentManagementAction } from '../reducers/contentMangementData';
import format from 'date-fns/format';
import { getCourseDurationByDate } from './CreateNewCourse/helper/getCourseDurationByDates';
interface CreateTestSeriesProps {
  goals: Goal[];
  userSuggestions: User[];
  getActiveGoals: Function;
  getUserSuggestions: Function;
  addCourseBasicDetails: Function;
  classes: any;
  packageId: string;
  history: any;
  location: any;
  addCourseTestSeries: Function;
  setSelectedGoalsForTestSeries: Function;
  duplicateSKUMessage: string;
}

interface CreateTestSeriesState {
  formData: CourseBasicDetails;
  formErrors: CourseBasicDetailsErrors;
  activateCreateCourseBtn: boolean;
  activeGoals: Goal[];
  userSuggestions: any[];
  loggedInUserFullName: string;
  clientId: string;
  courses: string[];
  selectedCourse: string;
  testCount: number;
  values: { value: string, label: string, id: string }[]
  searchBarGoalsValue: any;
  isMyPatClient:boolean;
  shareViewRights:boolean;
  isTestSeries: boolean;
}
class CreateTestSeries extends Component<CreateTestSeriesProps, CreateTestSeriesState> {
  userData = ACLService.getUserDetailsFromStorage();
  userId = this.userData.authenticatedUser.id;
  fullName = this.userData.authenticatedUser.fullName;
  //  clientID = this.userData.authenticatedUser.clients.map((c:any)=>{
  //   return c.id;
  // });
  clientId = this.userData.authenticatedUser.aclMetaData.clientId;
  constructor(props: CreateTestSeriesProps) {
    super(props);
    this.state = {
      formData: getCreateCourseDefaultFormData({
        id: this.userId,
        firstName: this.fullName.split(' ')[0],
        lastName: this.fullName.split(' ')[1],
        isRemovable: false
      }),
      formErrors: getCreateCourseInitailStateForErrors(),
      activateCreateCourseBtn: false,
      activeGoals: [],
      userSuggestions: [],
      loggedInUserFullName: '',
      clientId: '',
      courses: ['Standard Course', 'Goals'],
      selectedCourse: '',
      testCount: 1,
      values: [],
      searchBarGoalsValue: [],
      isMyPatClient:false,
      shareViewRights:false,
      isTestSeries: false
    };
  }

  componentDidMount() {
    this.props.getActiveGoals();
    this.props.getUserSuggestions({
      clientId: this.clientId,
    });
    const firstName = this.fullName.split(' ')[0];
    const lastName = this.fullName.split(' ')[1];
    const fullName = this.userData.authenticatedUser.fullName;
    const id = this.clientId;
    const { values } = this.state
    let updatedValues = [...values, { label: `${fullName} (You)`, value: fullName, id: this.userId, isRemovable: false }]
    this.setState({
      loggedInUserFullName: this.fullName,
      clientId: this.userId,
      values: updatedValues,
      isMyPatClient:this.clientId=="5b5702e095cbc921944632a9"
    }, () => this.updateUserSuggestions())
  }

  componentDidUpdate(prevProps: CreateTestSeriesProps) {
    if (prevProps.goals !== this.props.goals) {
      this.setActiveGoals(this.props.goals);
    }

    if (prevProps.userSuggestions !== this.props.userSuggestions) {
      const fullNames = this.prepareAdminNameSuggestions(this.props.userSuggestions);
      this.setState({
        userSuggestions: fullNames,
      }, () => {
        this.updateUserSuggestions();
      });
    }
    if (prevProps.duplicateSKUMessage !== this.props.duplicateSKUMessage) {
      const updatedFormErrors = { ...this.state.formErrors }
      const updatedSKU = { ...updatedFormErrors.sku }
      updatedSKU.SKUText = this.props.duplicateSKUMessage
      updatedFormErrors.sku = updatedSKU
      this.setState({
        formErrors: updatedFormErrors
      })
    }
    if (prevProps.packageId !== this.props.packageId) {
      localStorage.setItem('testCount', JSON.stringify(this.state.testCount));
      this.props.history.push(`/course-Management/testSeries/${this.props.packageId}`);
    }
  }

  setActiveGoals = (goalData: Goal[]) => {
    // const goalNameArray = goalData.map((goal) => goal.name);
    this.setState({
      activeGoals: goalData,
    });
  };

  validateFormData = (field: string, data?: any) => {
    this.setState((prevState: CreateTestSeriesState) => {
      const { formData, formErrors } = prevState;
      const {
        name,
        sku: { SKUText, SKUNumber, SKUYear },
        courseDetails,
        startDate,
        endDate,
        packageAdmins,
      } = formData;
      switch (field) {
        case 'name':
          formErrors.name = checkMinLength(name, 5) ? '' : 'Enter atleast 5 characters';
          break;
        case 'sku.SKUText':
          formErrors.sku.SKUText = isContainSpecialCharacters(data) ? 'No Special Characters Allowed' : checkMinLength(data, 3) ? '' : 'Enter atleast 3 characters';
          break;
        case 'sku.SKUNumber':
          formErrors.sku.SKUNumber = checkMinLength(SKUNumber.toString(), 1) ? '' : 'Enter atleast 1 character';
          break;
        case 'goal':
          formErrors.courseDetails = courseDetails.length > 0 ? '' : 'Select a goal';
          break;
        case 'courseAdmins':
          formErrors.packageAdmins = data !== null ? '' : 'Select atleast one course admin';
          break;
        default:
      }
      return formErrors;
    });
  };
  validateEmptyStrings = (formErrors: CourseBasicDetailsErrors) => {
    const { testCount } = this.state;
    const { name, sku, courseDetails, startDate, endDate, packageAdmins } = formErrors;
    return (
      name === '' &&
      sku.SKUText === '' &&
      sku.SKUNumber === '' &&
      courseDetails === '' &&
      startDate === '' &&
      endDate === '' &&
      packageAdmins === '' &&
      testCount >= 1
    );
  };
  canActivateCreateCourseBtn = () => {
    const { formErrors } = this.state;
    let activateCreateCourseBtn = false;

    if (this.validateEmptyStrings(formErrors)) {
      activateCreateCourseBtn = true;
    } else {
      activateCreateCourseBtn = false;
    }

    this.setState({
      activateCreateCourseBtn: activateCreateCourseBtn,
    });
  };

  handleChange = (event: any) => {
    const { name, value } = event.target;
    const updatedFormData = this.state.formData;
    const updatedFormErrors = this.state.formErrors;
    switch (name) {
      case 'name':
        const startRegex = /^[A-Za-z0-9 ]/;
        const endRegex=/[A-Za-z0-9 ]$/;
        if((startRegex.test(value) && endRegex.test(value)) || value === '') {
          updatedFormData.name = value.trimStart();
        }
        if (updatedFormErrors.name === 'untouched') {
          updatedFormErrors.name = '';
        }
        this.validateFormData('name');
        break;
      case 'skuText':
        let updatedSKUFormData = { ...updatedFormData.sku }
        updatedSKUFormData.SKUText = value.replace(/[^A-Z0-9]/ig, "");
        updatedFormData.sku = updatedSKUFormData;
        if (updatedFormErrors.sku.SKUText === 'untouched') {
          updatedFormErrors.sku.SKUText = '';
        }
        this.validateFormData('sku.SKUText', value);
        break;
      case 'skuNumber':
        updatedFormData.sku.SKUNumber = value.replace(/[^\w\s]/gi, '');
        if (updatedFormErrors.sku.SKUNumber === 'untouched') {
          updatedFormErrors.sku.SKUNumber = '';
        }
        this.validateFormData('sku.SKUNumber');
        break;
      case 'goal':
        updatedFormData.courseDetails = value;
        const SKUYear = value.split('-');
        updatedFormData.sku.SKUYear = SKUYear[SKUYear.length - 1];
        if (updatedFormErrors.courseDetails === 'untouched') {
          updatedFormErrors.courseDetails = '';
        }
        this.validateFormData('goal');
        break;
      case 'CourseCreated':
        this.setState({
          selectedCourse: value,
        });
        break;
      default:
    }
    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        this.canActivateCreateCourseBtn();
      }
    );
  };

  handleDateSelection = (date: any, type: string) => {
    const updatedFormData = this.state.formData;
    const updatedFormErrors = this.state.formErrors;
    const formattedDate = dateService.dateOnly(date);
    let newDate = new Date(date);
    switch (type) {
      case 'startDate':
        updatedFormData.startDate.label = formattedDate;
        newDate.setHours(0, 0, 0,0);
        updatedFormData.startDate.value = newDate.toISOString();
        updatedFormErrors.startDate = '';
        this.validateFormData('date');
        break;
      case 'endDate':
        updatedFormData.endDate.label = formattedDate;
        newDate.setHours(23, 59, 59,0);
        // let endDate=format(updatedFormData.endDate.value,"yyyy-MM-dd");
        // endDate=endDate+'T23:59:00.000Z';
        updatedFormData.endDate.value = newDate.toISOString();
        updatedFormErrors.endDate = '';
        this.validateFormData('date');
        const courseDuration = getCourseDurationByDate(updatedFormData.startDate.value, 
          date);
        updatedFormData.duration = courseDuration;
        
        break;
      default:
    }
    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        this.canActivateCreateCourseBtn();
      }
    );
  };

  renderSelectGoalOptions = () => {
    let options = [];
    options.push(<option value={''}>{'Select Goal'}</option>);
    _.map(this.state.activeGoals, (goal: string, index: number) =>
      options.push(
        <option key={index} value={goal}>
          {goal}
        </option>
      )
    );
    return options;
  };

  prepareAdminNameSuggestions = (data: User[]) => {
    // {label: 'Adam'}
    let users = data
      .map((user) => {
        if (user.firstName !== undefined &&
          user.firstName !== null
        )
          return user;
      })
      .filter((user) => user !== undefined)
      .map((user) => ({
        id: user && user._id,
        label: `${user && user.firstName} ${user &&
          user.lastName !== null &&
          user.lastName !== undefined &&
          user.lastName}`,
      }));

    return users;
  };
  updateUserSuggestions = () => {
    const { userSuggestions: allUserSuggestions } = this.props;
    const { formData, userSuggestions, values } = this.state;
    const { packageAdmins } = formData;
    let updatedUserSuggestions: any = [];
    allUserSuggestions.forEach((user) => {
      let addCurrentUser = true;
      const fullName = `${user.firstName} ${user.lastName}`
      values.forEach((admin) => {
        // const adminFullName = `${admin.firstName} ${admin.lastName}`
        if (user._id === admin.id) {
          addCurrentUser = false;
        }
      })
      if (addCurrentUser) {
        updatedUserSuggestions.push({ id: user._id, label: fullName })
      }
    })
    this.setState({
      userSuggestions: updatedUserSuggestions,
    })
  }

  handleCourseAdminNames = (
    names: { value: string; label: string; id: string }[]
  ) => {
    this.validateFormData('courseAdmins', names);
    if (names !== null) {
      // this.updateUserSuggestions();

      const admins = names.filter((name) => name.id);
      console.log(admins);
      let selectedAdmins: any = [];
      admins.forEach((admin) => {
        const currentUser = this.props.userSuggestions.filter(
          (user) => user._id === admin.id
        );
        selectedAdmins.push(currentUser[0]);
      });

      console.log(selectedAdmins)
      const trimmedAdminObjects = selectedAdmins.map((admin: User) => ({
        id: admin._id,
        firstName: admin.firstName,
        lastName: admin.lastName,
        isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ? false : true,
      }));
      console.log(trimmedAdminObjects);

      let updatedValues = trimmedAdminObjects.map((admin: any) => ({
        label: this.state.loggedInUserFullName.toString().includes(`${admin.firstName} ${admin.lastName}`) ? `${admin.firstName} ${admin.lastName} (You)` : `${admin.firstName} ${admin.lastName}`,
        value: this.state.loggedInUserFullName.toString().includes(`${admin.firstName} ${admin.lastName}`) ? `${admin.firstName} ${admin.lastName} (You)` : `${admin.firstName} ${admin.lastName}`,
        id: admin.id,
        isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ? false : true
      }))
      console.log('UPDATED VALUES--------->', updatedValues)


      this.canActivateCreateCourseBtn();
      this.setState((prevState: any) => {
        let { formData } = prevState;
        let { packageAdmins } = formData;

        let updatedFormData = { ...formData }
        let updatedPackageAdmins = [...trimmedAdminObjects]

        // packageAdmins = trimmedAdminObjects;
        updatedFormData.packageAdmins = updatedPackageAdmins;
        return {
          formData: updatedFormData,
          values: updatedValues
        };
      },
        () => {
          console.log(this.state.formData);

          this.canActivateCreateCourseBtn();
          this.updateUserSuggestions();
        }
      );
    } else {
      console.log('IN Handle Admin NAmes ELSE---------')
      let { formData } = this.state;
      let { packageAdmins } = formData;
      let updatedFormData = { ...formData }
      let updatedPackageAdmins = [...packageAdmins]
      // updatedPackageAdmins = [];
      updatedFormData.packageAdmins = updatedPackageAdmins;
      this.setState({
        formData: updatedFormData
      }, () => this.canActivateCreateCourseBtn())
    }
  };


  prepareCourseDetailArray = () => {
    // change it to _id
    const goal = this.props.goals.filter((goal) => this.state.formData.courseDetails.includes(goal.name));
    let goalData: any = [];
    goal.forEach((element: any) => {
      goalData.push({
        courseId: element._id,
        courseType: element.courseType,
        courseName: element.name,
      });
    });
    return goalData;
  };
  checkForEmptyAndUnTouch = (object: any, path: string) => {
    const result = _.get(object, path, '');
    return result !== '' && result !== 'untouched' ? true : false;
  };

  handleSubmit = () => {
    const { formData, testCount } = this.state;
    const updatedFormData = { ...formData };
    
    updatedFormData.type = CourseTypes.testSeries;
    updatedFormData.name = formData.name.trim(); 
    updatedFormData.targetYears = [formData.sku.SKUYear];
    const goalData = this.prepareCourseDetailArray();
    updatedFormData.courseDetails = goalData;
    updatedFormData.sku = buildSKUString(updatedFormData.sku);
    updatedFormData.startDate = updatedFormData.startDate.value;
    updatedFormData.expiryDate = updatedFormData.endDate.value;
    // let endDate=format(updatedFormData.endDate.value,"yyyy-MM-dd");
    //      endDate=endDate+'T23:59:00.000Z';
    //  updatedFormData.expiryDate =endDate
    updatedFormData.isSharedWithFiitjeeClients=this.state.shareViewRights;
    updatedFormData.subType = this.state.isTestSeries ? 'previous-year': '';
    this.props.addCourseBasicDetails(updatedFormData);
    // this.props.setSelectedGoalsForTestSeries(goalData);
  };
  handleSelectedCourses = () => { };
  handleTestCount = (event: any) => {
    if(event.target.value>999)
      return ;
    const { formErrors } = this.state;
    console.log(event.target.value);
    this.setState({ testCount: event.target.value }, () => {
      this.canActivateCreateCourseBtn();
    });
  };

  handleGoalsNames = (selectedGoals: any) => {
    const updatedFormData = this.state.formData;
    const updatedFormErrors = this.state.formErrors;
    let SKUYears: any = [];
    let minValue;
    // let { searchBarGoalsValue } = this.state;
    let searchBarGoalsValue: any = [];
    // maintainValidationHere
    updatedFormData.courseDetails = [];
    selectedGoals && selectedGoals.forEach(({ value, id, label }: any) => {
      updatedFormData.courseDetails.push(value);
      const SKUYear = value.split('-');
      SKUYears.push(Number(SKUYear[SKUYear.length - 1]));
      minValue = Math.min(...SKUYears);
      searchBarGoalsValue.push({
        value, id, label, isRemovable: true
      });
    });
    updatedFormData.sku.SKUYear = minValue;
    if (updatedFormErrors.courseDetails === 'untouched') {
      updatedFormErrors.courseDetails = '';
    }
    this.validateFormData('goal');
    this.setState({
      formData: updatedFormData,
      formErrors: updatedFormErrors,
      searchBarGoalsValue
    }, () => {
      this.canActivateCreateCourseBtn();
    });
  };
  setShareEditKey=()=>{
    this.setState({shareViewRights:!this.state.shareViewRights});
  }

  setTestSeriesValue=()=>{
    this.setState({isTestSeries:!this.state.isTestSeries});
  }
  
  render() {
    const { classes } = this.props;
    const { formData, formErrors, testCount } = this.state;
    let startDate = _.get(formData, 'startDate.value', '');
    startDate = new Date(startDate);

    let endDate = _.get(formData, 'endDate.value', '');
    endDate = new Date(endDate);

    return (
      <Modal
        BackdropProps={{ invisible: true }}
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
        className={[
          classes.fontSizeLG,
          classes.fontWeight500,
          classes.modal,
        ].join(" ")}
        open={true}
      >
        <div className={classes.paper}>
          <Card elevation={0} classes={{ root: classes.cardContainer }}>
            <DialogHeader
              urlName='/course-management'
              iconNode={
                <IconButton
                  aria-label='settings'
                // onClick={dialogCloseHandler}
                >
                  <CloseIcon
                  // className={classes.fontSizeLG}
                  />
                </IconButton>
              }
              headerTitle=
              {
                <>
                  <Typography className={classes.courseTitle}>
                    Create Test Series
              </Typography>
                </>
              }

            />

            <CardContent className={classes.cardContentStyle}>
              <Grid container justify='center'>
                <Grid item xs={9}>
                  <Typography className={classes.cardHeading}>
                    Course Basic Details<span>*</span>{' '}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={8} justify='center'>
                <Grid item xs={9}>
                  <Grid container spacing={16}>
                    <Grid item xs={6}>
                      <Typography className={classes.inputLable}>Course Name</Typography>
                      <MyPATTextField
                        //   className={classes.inputWidth}
                        fullWidthControl
                        inputId='name'
                        name='name'
                        placeholder='Course Name'
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={this.state.formData.name || ''}
                        onChange={this.handleChange.bind(this)}
                        error={this.checkForEmptyAndUnTouch(formErrors, 'name')}
                        errorText={this.state.formErrors.name}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography className={classes.inputLable}>SKU</Typography>
                      <Grid container spacing={16}>
                        <Grid item xs={6}>
                          <MyPATTextField
                            //   className={classes.inputWidth}
                            fullWidthControl
                            inputId='skuText'
                            name='skuText'
                            placeholder='E.g. JEE'
                            // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                            value={this.state.formData.sku.SKUText || ''}
                            onChange={this.handleChange.bind(this)}
                            error={this.checkForEmptyAndUnTouch(formErrors, 'sku.SKUText')}
                            errorText={this.state.formErrors.sku.SKUText}
                          />
                          <span className={classes.smallInfo}>Atleast 3 characters </span>
                        </Grid>

                        <Grid item xs={6}>
                          <MyPATTextField
                            //   className={classes.inputWidth}
                            fullWidthControl
                            inputId='skuNumber'
                            name='skuNumber'
                            placeholder='01'
                            // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                            value={this.state.formData.sku.SKUNumber || ''}
                            onChange={this.handleChange.bind(this)}
                            error={this.checkForEmptyAndUnTouch(formErrors, 'sku.SKUNumber')}
                            errorText={this.state.formErrors.sku.SKUNumber}
                            onKeyPress={onlyAllowNumbers}
                          />
                          <span className={classes.smallInfo}>Value must be numeric </span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* <Grid container spacing={8}>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    // className={classes.fontSizeMD}
                  >
                    Course Name
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    // className={classes.fontSizeMD}
                  >
                    SKU
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={8}>
                <Grid item xs={4}>
                  <MyPATTextField
                    //   className={classes.inputWidth}
                    fullWidthControl
                    inputId="name"
                    name="name"
                    // placeholder=""
                    // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                    value={this.state.formData.name || ""}
                    onChange={this.handleChange.bind(this)}
                    error={
                       this.checkForEmptyAndUnTouch(formErrors,"name")
                    }
                    errorText={this.state.formErrors.name}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MyPATTextField
                    //   className={classes.inputWidth}
                    fullWidthControl
                    inputId="skuText"
                    name="skuText"
                    // placeholder=""
                    // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                    value={this.state.formData.sku.SKUText || ""}
                    onChange={this.handleChange.bind(this)}
                    error={
                        this.checkForEmptyAndUnTouch(formErrors,"sku.SKUText")  
                    }
                    errorText={this.state.formErrors.sku.SKUText}
                  />
                </Grid>
                <span>-</span>
                <Grid item xs={3}>
                  <MyPATTextField
                    //   className={classes.inputWidth}
                    fullWidthControl
                    inputId="skuNumber"
                    name="skuNumber"
                    // placeholder=""
                    // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                    value={this.state.formData.sku.SKUNumber || ""}
                    onChange={this.handleChange.bind(this)}
                    error={
                        this.checkForEmptyAndUnTouch(formErrors,"sku.SKUNumber") 
                    }
                    errorText={this.state.formErrors.sku.SKUNumber}
                    onKeyPress={onlyAllowNumbers}
                  />
                </Grid>
              </Grid> */}

              {/* Select goal and start and end date */}
              <Grid container spacing={8} justify='center' className={classes.mt30}>
                <Grid item xs={9}>
                  <Grid container justify='center' spacing={16}>
                    <Grid item xs={6}>
                      <Typography className={classes.inputLable}>Goal</Typography>
                      {/* <MyPATSelect
                      value={this.state.formData.courseDetails}
                      name="goal"
                      onChange={(e: any) => this.handleChange(e)}
                    >
                      {this.renderSelectGoalOptions()}
                    </MyPATSelect> */}
                      {/* <div> */}
                      <SearchBarWithChips
                        suggestions={prepareGoalsForSuggestion(this.state.activeGoals)}
                        placeholderText='Select Goal'
                        onSelection={this.handleGoalsNames}
                        classes={{ root: classes.searchBarChips }}
                        values={this.state.searchBarGoalsValue}
                        backspaceRemoves={true}
                        notFound="No Goal Found"
                      />
                      {/* </div> */}
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container spacing={16}>
                        <Grid item xs={6} className={classes.customCalendar}>
                          <Typography className={classes.inputLable}>Start Date </Typography>
                          <MyPATCalendar
                            fullWidthControl
                            onChange={(dateVal: string) => this.handleDateSelection(dateVal, 'startDate')}
                            date={this.state.formData.startDate.label}
                            placeholder='Select Start Date'
                            // minDate={new Date()}
                          />
                        </Grid>
                        <Grid item xs={6} className={classes.customCalendar}>
                          <Typography className={classes.inputLable}>End Date</Typography>
                          <MyPATCalendar
                            fullWidthControl
                            onChange={(dateVal: string) => this.handleDateSelection(dateVal, 'endDate')}
                            date={this.state.formData.endDate.label}
                            disabled={!this.state.formData.startDate.label}
                            placeholder='Select End Date'
                            minDate={startDate}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>



              <Grid container spacing={8} justify='center' className={classes.mt30}>
                <Grid item xs={9}>
                  <Grid container spacing={16}>
                    <Grid item xs={6}>
                      <Typography className={classes.inputLable}>Test Count</Typography>
                      <MyPATTextField
                        //   className={classes.inputWidth}
                        fullWidthControl
                        inputId='testCount'
                        name='testCount'
                        // placeholder=""
                        // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                        value={testCount}
                        onChange={this.handleTestCount.bind(this)}
                        onKeyPress={onlyAllowNumbers}
                        required
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography className={classes.inputLable}>Course Admin</Typography>
                      <SearchBarWithChips
                        suggestions={this.state.userSuggestions}
                        placeholderText="Select Course Admins"
                        onSelection={this.handleCourseAdminNames}
                        // loggedInUserFullName={this.state.loggedInUserFullName}
                        classes={{ root: classes.searchBarChips }}
                        notFound='No User Found'
                        values={this.state.values}
                        isClearable={false}
                        backspaceRemoves={false}
                      />
                    </Grid>
                    {this.state.isMyPatClient &&
                     <> 
                      <Grid item xs={6}>
                        <Typography
                          style={{marginTop: '20px'}}
                          className={[
                            classes.inputLable
                          ].join(" ")}
                        >
                          Share Course(with view and copy rights)
                        </Typography>
                        <FormControlLabel
                          className={[classes.updateLabel, classes.updatedLabel].join(' ')}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.shareViewRights
                              }
                              onChange={() =>
                                this.setShareEditKey()
                              }
                            />
                          }
                          label="Share this course with FIITJEE Clients?"
                          labelPlacement="start"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        {/* Test Series Type */}
                        <Typography
                          style={{marginTop: '20px'}}
                          className={[
                            classes.inputLable
                          ].join(" ")}
                        >
                          Test Series Type
                        </Typography>
                        <FormControlLabel
                          className={[classes.updateLabel, classes.updatedLabel].join(' ')}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.isTestSeries
                              }
                              onChange={() =>
                                this.setTestSeriesValue()
                              }
                            />
                          }
                          label="Previous Year Tests Series"
                          labelPlacement="start"
                        />
                      </Grid>
                      {/* End */}
                      </>}
                     
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>

            <DialogFooter
              htmlElements={
                <>
                  <Button
                    variant='contained'
                    color='primary'
                    // className={classes.btnCreateGoal}
                    type='submit'
                    disabled={!this.state.activateCreateCourseBtn}
                    onClick={this.handleSubmit}
                  >
                    Create Course
                </Button>
                </>
              }
            />
          </Card>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state: any) => ({
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  userSuggestions: state.courseMangementData.courseManagementReducer.userSuggestions,
  duplicateSKUMessage: state.courseMangementData.courseManagementReducer.errors.duplicateSKUMessage,
  packageId: state.courseMangementData.courseManagementReducer.testSeries.packageId,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getActiveGoals: getActiveGoals,
      getUserSuggestions: getUserSuggestions,
      addCourseBasicDetails: addCourseBasicDetails,
      addCourseTestSeries: addCourseTestSeries,
      setSelectedGoalsForTestSeries: contentManagementAction.setSelectedGoalsForTestSeries,
    },
    dispatch
  );

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(CreateTestSeries)));
